function DarkModeImage() {

	const IMAGE_SELECTORS = 'img, picture img, img[srcset], picture source, picture source[srcset]';
	const SELECTORS = 'body *:not(.wp-dark-mode-ignore):not(.wp-dark-mode-ignore *):not(iframe):not(script):not(style)';

	var mutationThrottle = null

	/**
	 * Replace images
	 */

	const allImages = () => {
		return document.querySelectorAll(IMAGE_SELECTORS);
	}

	function initImages() {
		// Set global CSS img opacity inherit
		document?.body.style.setProperty('--wpdm-img-opacity', 1);

		// element having background image.
		var elements = document.querySelectorAll(SELECTORS);

		if (!elements) return;

		replaceBackgroundImages(elements);

		const images = allImages();
		if (images && images.length) {
			replaceImages(images);
			excludeFilterImages(images);
		}

		document.addEventListener('wp_dark_mode', (e) => {
			replaceBackgroundImages(elements);

			const images = allImages();
			
			if (images && images.length) {
				replaceImages(images);
				excludeFilterImages(images);
			}

		});
		

		if (!wp_dark_mode_json.options.performance_track_dynamic_content) {
			return;
		}

		// Create a MutationObserver to watch for src attribute changes
		const observer = new MutationObserver((mutations) => {
			if ( mutationThrottle ) return;
			mutationThrottle = true;
			setTimeout(() => {
				mutationThrottle = null;
			}, 500);
			
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
					const img = mutation.target;
					// Only process if the src was actually set by lazy loading (not by us)
					if (img.src && img.src.startsWith('http') && !img.dataset.processed) {
						img.dataset.processed = 'true';
						replaceImage(img);
					}
				}
			});
		});
		
		// Observe all img elements for src attribute changes
		document.querySelectorAll('img').forEach(img => {
			observer.observe(img, {
				attributes: true,
				attributeFilter: ['src']
			});
		});
	}

	function init() {
		if (document.body) {
			initImages()
		} else {
			document.addEventListener('DOMContentLoaded', initImages);
		}
	}

	
	// Replace dark images
	function loadDarkImage(image) {

		// For lazy loaded.
		image.srcset = image.srcset || image.dataset.srcset || image.dataset.lazySrcset || '';
		image.src = image.src || image.dataset.src || image.dataset.lazySrc || '';

		// If has srcset.
		if (image.srcset && image.srcset.startsWith('http')) {
			let currentSrc = image.srcset;

			wp_dark_mode_json.options.image_replaces.forEach((img) => {
				currentSrc = currentSrc.replaceAll(img.light, img.dark);
			});

			image.dataset.lightSrcset = image.srcset;
			image.srcset = currentSrc;
		} 
		
		if (image.src && image.src.startsWith('http')) {
			
			const darkSrc = getDarkSrc(image.src);
			if (darkSrc) {
				image.dataset.lightSrc = image.src;
				image.src = darkSrc;
			}
		}
		
	}

	// Replace light images
	function loadLightImage(image) {
		
		// If has srcset.
		if (image.dataset.lightSrcset) {
			image.srcset = image.dataset.lightSrcset;
		}

		if (image.dataset.lightSrc) {
			image.src = image.dataset.lightSrc;
		}
	}

	function replaceImage(image) {

		if (!image) return;

		// Bail, if image src is not set.
		if (image.classList.contains('wp-dark-mode-ignore')) {
			return;
		}
		
		if (WPDarkMode.isActive) {
			loadDarkImage(image);
		} else {
			loadLightImage(image);
		}
	}
	// Replace images
	function replaceImages(images) {

		// Bail, if image replaces are not set.
		if (!wp_dark_mode_json.options.image_replaces.length) return;

		if (!images || !images.length) return;
		
		// Replace images.
		images.forEach(replaceImage);
	}

	function hasBgImage(el) {
		return window.getComputedStyle(el)?.getPropertyValue('background-image') !== 'none' ||
			window.getComputedStyle(el, '::after')?.getPropertyValue('background-image') !== 'none' ||
			window.getComputedStyle(el, '::before')?.getPropertyValue('background-image') !== 'none';
	}


	function replaceBackgroundImage(element) {

		if (!element) return;
		if (!hasBgImage(element)) return;

		element.classList.add('wp-dark-mode-bg-image');

		var backgroundImage = window.getComputedStyle(element).getPropertyValue('background-image');

		backgroundImage = backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2').split(',')[0];

		// change the background image to dark mode if dark mode is enabled
		if (WPDarkMode.isActive) {
			const darkSrc = getDarkSrc(backgroundImage);

			if (darkSrc) {
				element.style.background = `url(${darkSrc})`;
				element.style.backgroundImage = `url(${darkSrc})`;

				// Set light src.
				element.dataset.lightSrc = backgroundImage;
				element.dataset.darkSrc = darkSrc;
			}
		} else {
			// change the background image to light mode if dark mode is disabled
			const lightSrc = element.dataset.lightSrc;
			if (lightSrc) {
				element.style.background = `url(${lightSrc})`;
				element.style.backgroundImage = `url(${lightSrc})`;
			}
		}
	}
	// Background images
	function replaceBackgroundImages(elements) {
		// Iterate through the selected elements
		elements.forEach(replaceBackgroundImage);
	}

	// Get dark src
	function getDarkSrc(src) {
		// Bail, if src is not set.
		if (!src) return;

		const replaceable_images = wp_dark_mode_json.options.image_replaces || false;
		if (!replaceable_images) return false;

		const imagePair = replaceable_images.find((img) => {
			// remove query string from image src
			const srcWithoutQuery = src.split('?')[0];

			return img.light === srcWithoutQuery
		});

		if (!imagePair) return false;

		return imagePair.dark;
	}

	// Exclude filter images
	function excludeFilterImages(images) {
		const lowBrightnessExcludes = wp_dark_mode_json.options.image_enabled_low_brightness ? wp_dark_mode_json.options.image_low_brightness_excludes : false;
		const lowGrayscaleExcludes = wp_dark_mode_json.options.image_enabled_low_grayscale ? wp_dark_mode_json.options.image_low_grayscale_excludes : false

		if (images && images.length) {
			images.forEach((image) => {
				const src = image.src;

				if (lowBrightnessExcludes && lowBrightnessExcludes.includes(src)) {
					// Set filter to 0.
					image.style.setProperty('--wpdm-img-brightness', '100%');
				}

				if (lowGrayscaleExcludes && lowGrayscaleExcludes.includes(src)) {
					// Set filter to 0.
					image.style.setProperty('--wpdm-img-grayscale', '0%');
				}
			});
		}

	}

	return {
		init
	}
}

export default DarkModeImage;